import { Component, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import {
  StripeService,
  // Elements,
  // Element as StripeElement,
  // ElementsOptions
} from 'ngx-stripe';
import { ApiService, EventEmitterService } from "src/app/shared/services";
import { STATE_LIST, COUNTRY_LIST } from "./../../../shared/constants";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from "@angular/cdk/layout";
import { IOrderAmount } from "../../../shared/models";
import { PromoCodeService } from "../../../shared/services/promo-code/promo-code.service";
import { PixelService } from "../../../shared/services/facebook-pixel/pixel.service";
import { MatDialog } from "@angular/material/dialog";
import { NotEligibleDialogComponent } from "./not-eligible-dialog/not-eligible-dialog.component";
import { NotAvailableDialogComponent } from "./not-available-dialog/not-available-dialog.component";
import { OrderListApiService } from "src/app/modules/order-list/order-list-api.service";
import { DatePipe } from "@angular/common";
import { EnvService } from "../../../shared/services/env.service";

@Component({
  selector: "app-payment",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.less"],
  providers: [DatePipe],
})
export class PaymentComponent implements OnInit {
  // elements: Elements;
  // card: StripeElement;
  // cardNumber: StripeElement;
  // cardExpiry: StripeElement;
  // cardCvc: StripeElement;
  // elementsOptions:ElementsOptions;
  elements: any;
  card: any;
  cardNumber: any;
  cardExpiry: any;
  cardCvc: any;
  elementsOptions: any;
  stripeTest: FormGroup;
  customerEmail: string;
  customer = true;
  shipping = false;
  billing = false;
  payment = false;
  statesArray = [];
  billingStatesArray = [];
  countryArray = [];
  cartProducts = [];
  spinner = "assets/image/spinner.gif";
  subTotalAmount = 0;
  cartProductsLength: number;
  totalShippingCharge = 0;
  totalAmount: number;
  customerData = {
    email: null,
    name: null,
    token: null,
    ip: null,
    payment_method: 'paypal',

    shipping_f_Name: null,
    shipping_l_Name: null,
    shipping_company_name: null,
    shipping_phone: null,
    shipping_address_line1: null,
    shipping_address_line2: null,
    shipping_city: null,
    shipping_country: null,
    shipping_state: null,
    shipping_zipcode: null,
    billing_f_Name: null,
    billing_l_Name: null,
    billing_company_name: null,
    billing_phone: null,
    billing_address_line1: null,
    billing_address_line2: null,
    billing_city: null,
    billing_country: null,
    billing_state: null,
    billing_zipcode: null,
    promo: "",
    shippingId: 0,
    billingId: 0
  };
  country = "";
  isBillingAddressSame = true;
  isEmailValid = true;
  isRequiredFieldsPresent = true;
  isPaymentExecuting = false;
  cardErrorMsg: string;
  bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset
  );
  bpTabletObserver: Observable<BreakpointState> =
    this.breakpointObserver.observe(Breakpoints.Tablet);
  bpSubscription: Subscription;
  bpTabletSubscription: Subscription;
  isHandset: boolean;
  isLoading = true;
  localStorageUser = {};
  eventSubscription: Subscription;
  orderAmount: IOrderAmount;
  isStateUpdating: boolean;
  isCountryUpdating: boolean;
  isTablet = false;
  // For PromoCodes
  isPromoCodeBoxVisible = false;
  promoCode: string;
  promoCodeError = false;
  promoCodeErrorMessage: string;
  isPromoCodeApplicable = false;
  promoCodeDiscount = 0;
  promoCodeDetails: any;
  isPromoCodeProcessing: boolean = false;

  giftCard: string = '';
  giftCardErrorMessage: string = '';
  isGiftCardProcessing: boolean = false;

  stateParam = "";
  countryParam = "";
  promoParam = "";

  testimonialToShow: any;
  originalStatesList: any[] = [];
  allCountries: any[] = [];
  productsFromStatusCall: any[] = [];
  id: any;
  currentSection: string;
  carouselNo: number = 2.5;
  updatedBilling: boolean;
  updatedShipping: boolean;
  @ViewChild('f') form!: NgForm;
  lastuserId: any;
  height: number
  walletCreditsAvailable: number;
  walletCreditsUsed: number;
  walletCreditsRemaining: number;
  isWalletApplied: boolean;
  successGiftCard: string;
  userType = 0;
  loadPayment: boolean = true;


  constructor(
    private fb: FormBuilder,
    private stripeService: StripeService,
    private apiService: ApiService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private eventEmitterService: EventEmitterService,
    private promoCodeService: PromoCodeService,
    private pixelService: PixelService,
    private dialog: MatDialog,
    public env: EnvService
  ) {
    this.height = window.innerHeight;
    this.allCountries = COUNTRY_LIST;
  }


  @HostListener('window:resize', ['$event'])
  resize(event) {
    this.carouselNo = window.innerWidth < 600 ? 1.2 : event.target.innerWidth < 1480 ? 1.5 : 2.5;
    this.height = window.innerHeight;
  }

  ngOnDestroy(): void {
    this.apiService.cartProducts = null;
  }
  get leftContentHeight() {
    return document.getElementById('leftContent')?.offsetHeight;
  }
  ngOnInit() {
    this.country = "USA";
    this.carouselNo = window.innerWidth < 600 ? 1.2 : window.innerWidth < 1480 ? 1.5 : 2.5;
    this.customerData.shipping_country = "USA";
    this.userType = JSON.parse(localStorage.getItem("user")).authorization;

    this.billingCountryChanged();
    this.getCartProducts(false, '');
    this.getStatesForCountry();
    this.loadStripe();

    this.bpSubscription = this.bpObserver.subscribe(
      (handset: BreakpointState) => {
        this.isHandset = handset.matches;
      }
    );
    this.bpTabletSubscription = this.bpTabletObserver.subscribe(
      (tablet: BreakpointState) => {
        this.isTablet = tablet.matches;
      }
    );

    this.apiService.getTestimonials('?type=shop&sortby=serial&sorttype=asc').subscribe((testimonials: any[]) => {
      const randomIdx = Math.round(Math.random() * 10) % testimonials.length;
      this.testimonialToShow = testimonials[randomIdx];
    });

    this.eventSubscription = this.eventEmitterService.userChangeEvent
      .asObservable()
      .subscribe((user) => {
        if (this.lastuserId !== user.id) {
          this.lastuserId = user.id;
          this.localStorageUser = user;
          if (this.apiService.cartProducts) {
            this.getCartProductsFromStorage();
          } else {
            this.getCartProducts(false, this.customerData.shipping_state);
          }
        }
      });
  }


  loadStripe() {
    this.stripeTest = this.fb.group({
      name: ['', [Validators.required]]
    });

    this.stripeService.elements(this.elementsOptions).subscribe((elements) => {
      this.elements = elements;
      // Only mount the element the first time
      if (!this.card) {
        const elementStyles = {
          base: {
            color: '#32325D',
            fontWeight: 500,
            fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
              color: '#CFD7DF'
            },
            ':-webkit-autofill': {
              color: '#e39f48'
            }
          },
          invalid: {
            color: '#E25950',
            '::placeholder': {
              color: '#FFCCA5'
            }
          }
        };
        const elementClasses = {
          focus: 'focused',
          empty: 'empty',
          invalid: 'invalid'
        };
        this.cardNumber = this.elements.create('cardNumber', {
          style: elementStyles
        });
        this.cardNumber.mount('#form-card-number');
        this.cardExpiry = this.elements.create('cardExpiry', {
          style: elementStyles
        });
        this.cardExpiry.mount('#form-card-expiry');
        this.cardCvc = this.elements.create('cardCvc', {
          style: elementStyles
        });
        this.cardCvc.mount('#form-card-cvc');
      }
    });
  }

  onDestroy(): void {
    this.bpSubscription.unsubscribe();
    this.bpTabletSubscription.unsubscribe();
    this.eventSubscription.unsubscribe();
  }

  decodeHtml(text: string): string {
    const htmlComponent = document.createElement("textarea");
    htmlComponent.innerHTML = text;
    return htmlComponent.value;
  }

  getCartProductsFromStorage() {
    this.cartProducts = this.apiService.cartProducts.products;
    this.orderAmount = this.apiService.cartProducts.order;
    this.customerData.email = this.apiService.cartProducts.user.emailid;
    this.isLoading = false;
    if (
      this.cartProducts.some(
        (s) => s.inventory.inventory_product_details.shipto_ca == "1"
      )
    ) {
      this.countryArray = COUNTRY_LIST;
    } else {
      this.countryArray = COUNTRY_LIST.filter(
        (f) => f.abbreviation == "USA"
      );
    }
  }
  get allowedUser() {
    return ('' + this.userType) == '0' || ('' + this.userType) == '1'
  }

  getCartProducts(hasState, state) {
    this.isLoading = true;
    this.apiService.getCartProduct(hasState, state, this.isPromoCodeApplicable, this.isPromoCodeApplicable ? this.promoCodeDetails.code : '', this.activeWallet).subscribe(
      (payload: any) => { 
        this.activePromo = payload.promo_details?.code; 
        this.updateCartUI(payload);
        if (payload.order) {
          this.walletCreditsAvailable = payload.order.wallet_credit_available;
          this.walletCreditsUsed = payload.order.wallet_used;
          if (this.walletCreditsUsed > 0) {
            this.isWalletApplied = true;
          } else {
            this.isWalletApplied = false;
          }
          this.walletCreditsRemaining = payload.order.wallet_remaining;
        }
        this.customerData.email = payload.user.emailid;
        this.isLoading = false;

        if (
          this.cartProducts.some(
            (s) => s.inventory.inventory_product_details.shipto_ca == "1"
          )
        ) {
          this.countryArray = COUNTRY_LIST;
        } else {
          this.countryArray = COUNTRY_LIST.filter(
            (f) => f.abbreviation == "USA"
          );
        }
        // this.countryArray = COUNTRY_LIST;
      },
      (error: any) => {
        this.isLoading = false;

      }
    );
  }

  isDiscounted(product): boolean {
    if (product) {
      if (product?.show_vip) {
        return Number(product.was_price) > Number(product.design_price);
      }
      return Number(product.was_price) > Number(product.retail_price);
    } else {
      return false
    }
  }

  executePayment(event) {
    this.customerData.billing_country = "USA";
    const name =
      this.customerData.billing_f_Name + " " + this.customerData.billing_l_Name;
    localStorage.setItem("registeredName", name);
    if (event.status === "COMPLETED") {
      localStorage.setItem("cart", "0");
      this.router.navigate([`order/${event.order_id}`]);
      this.pixelService.trackPurchase(event);
    } else {
    }
  }

  buy() {
    this.customerData.billing_country = 'USA';
    const data = this.customerData;

    const condition =
      data.email &&
      data.shipping_f_Name &&
      data.shipping_l_Name &&
      data.shipping_address_line1 &&
      data.shipping_state &&
      data.shipping_zipcode &&
      data.shipping_phone &&
      data.shipping_country &&
      data.shipping_city &&
      data.billing_f_Name &&
      data.billing_l_Name &&
      data.billing_address_line1 &&
      data.billing_state &&
      data.billing_zipcode &&
      data.billing_phone &&
      data.billing_country &&
      data.billing_city;

    if (!condition) {
      this.isRequiredFieldsPresent = false;
      this.cardErrorMsg = 'Please fill all the required fields';
      return;
    }

    this.isPaymentExecuting = true;
    this.isRequiredFieldsPresent = true;

    const name = `${data.billing_f_Name} ${data.billing_l_Name}`;

    /** =========================
     * STRIPE PAYMENT
     * ========================= */
    if (this.loadPayment) {
      this.stripeService
        .createToken(this.cardNumber, { name })
        .subscribe((result: any) => {
          if (result.token) {
            const userId = sessionStorage.getItem('user_id');

            const finalData = {
              shipping_address_id: this.selectedShipping.id,
              billing_address_id: this.selectedBilling.id,
              user_id: userId,
              promo: this.promoCodeDetails ? this.promoCodeDetails.code : '',
              email: data.email,
              token: result.token.id,
              ip: result.token.client_ip,
              payment_method: 'Stripe',
              wallet_code: this.activeWallet
            };

            localStorage.setItem('registeredName', name);

            this.apiService.postStripeToken(finalData).subscribe(
              (payload: any) => {
                this.isPaymentExecuting = false;

                if (payload.status === 'succeeded') {
                  localStorage.setItem('cart', '0');
                  this.router.navigate([`order/${payload.order_id}`]);
                } else {
                  this.isRequiredFieldsPresent = false;
                  this.cardErrorMsg = payload?.errors?.message || 'Payment failed';
                }
              },
              () => {
                this.isPaymentExecuting = false;
              }
            );
          } else if (result.error) {
            this.isPaymentExecuting = false;
            this.cardErrorMsg = result.error.message;
          }
        });

      return;
    }

    /** =========================
     * WALLET ONLY PAYMENT
     * ========================= */
    this.cardErrorMsg = '';
    const obj = {
      shipping_address_id: this.selectedShipping.id,
      billing_address_id: this.selectedBilling.id,
      email: data.email,
      name,
      payment_method: 'wallet_only',
      wallet_code: this.activeWallet,
    };
    localStorage.setItem('registeredName', name);

    this.apiService.createOrder(obj).subscribe(
      (payload: any) => {
        this.isPaymentExecuting = false;
        if (payload.order_id) {
          localStorage.setItem('cart', '0');
          this.router.navigate([`order/${payload.order_id}`]);
        } else {
          this.cardErrorMsg = 'Something went wrong, please try again later.';
        }
      },
      () => {
        this.isPaymentExecuting = false;
        this.cardErrorMsg = 'Something went wrong, please try again later.';

      }
    );
  }

  getResponse(e) {
    const entryIndex = this.productsFromStatusCall.findIndex(
      (f) => f.sku === e.sku
    );
    if (entryIndex > -1) {
      this.productsFromStatusCall[entryIndex] = e;
    } else {
      this.productsFromStatusCall.push(e);
    }
  }

  updateAccordion(section, sec = '', form) {

    if (sec === 'shipping' && this.form && this.form.invalid) {
      this.form.form.markAllAsTouched();
      return;

    }
    if (sec === 'billing' && this.form && this.form.invalid) {
      this.form.form.markAllAsTouched();

      return;

    }
    this.customer = false;
    //     if(section==='customer'){
    //     this.customerData.shipping_country = "USA";
    // this.customerData.shipping_state = this.statesArray[0].abbreviation;
    //     }




    if (section == "billing") {
      if (
        this.customerData.shipping_country == "Canada" &&
        this.cartProducts.some(
          (s) => s.inventory.inventory_product_details && s.inventory.inventory_product_details.shipto_ca == "0"
        )
      ) {
        this.dialog.open(NotEligibleDialogComponent, {});
        return;
      }
    }


    const productDetails = [];
    if (this.productsFromStatusCall.length > 0) {
      this.productsFromStatusCall.forEach((f) => {
        this.cartProducts.forEach((e) => {
          if (f.sku == e.product_sku) {
            productDetails.push({ ...e, ...f });
          }
        });
      });

      const prdData = productDetails.filter((f) => f.isNotAvailable);
      if (prdData.length > 0) {
        this.dialog.open(NotAvailableDialogComponent, {
          data: prdData,
        });
      }
    }

    // if(sec==='shipping'){
    //   this.getCartProducts(true,this.customerData.shipping_state)
    // }


    if (section === "billing") {
      this.onCheckboxChange(this.isBillingAddressSame);
      if (!this.customerData.billing_f_Name) {
        this.billing = true;
      } else if (this.isBillingAddressSame) {
        //  this.moveToPay();
      }
      if (this.isBillingAddressSame) {
        this.updatedBilling = false;
      } else {
        this.updatedBilling = true;
        this.billing = false;
      }
    } else {
      this[section] = true;
      if (this.payment) {
        this.currentSection = 'payment';
        this.moveToPay();
      }
    }


    if (section === "billing" && this.form.valid) {

      let userId = sessionStorage.getItem('user_id');
      let obj = {}
      if (sec === 'shipping') {
        obj = {
          first_Name: this.form.value.shipping_f_Name,
          last_Name: this.form.value.shipping_l_Name,
          address_line_1: this.form.value.shipping_address_line1,
          address_line_2: this.form.value.shipping_address_line2,
          city: this.form.value.shipping_city,
          // email: this.form.value.email,
          user_id: userId,
          company_name: this.form.value.shipping_company_name,
          country: this.form.value.shipping_country,
          phone: this.form.value.shipping_phone,
          state: this.form.value.shipping_state,
          zipcode: this.form.value.shipping_zipcode,
          id: this.id,
          status: 1
        }
        this.shipping = false;
      } else if (sec === 'billing') {
        obj = {
          first_Name: this.form.value.billing_f_Name,
          last_Name: this.form.value.billing_l_Name,
          address_line_1: this.form.value.billing_address_line1,
          address_line_2: this.form.value.billing_address_line2,
          city: this.form.value.billing_city,
          user_id: userId,
          company_name: this.form.value.billing_company_name,
          country: this.form.value.billing_country,
          phone: this.form.value.billing_phone,
          state: this.form.value.billing_state,
          zipcode: this.form.value.billing_zipcode,
          id: this.id,
          status: 1
        }
        this.billing = false;
      }
      this.payment = false;
      this.apiService.saveAddressBook(obj).subscribe(re => {
        let order_email = sessionStorage.getItem('order_email');
        if (sec === 'shipping') {
          this.updatedShipping = true;
          this.currentSection = 'billing';

          if (this.updatedBilling === true) {
            this.moveToPay();
          }
        } else if (sec === 'billing') {
          this.updatedBilling = true;
          this.moveToPay();
        }

        if (!this.isBillingAddressSame && sec === 'shipping') {
          this.updatedBilling = false;
          this.payment = false;
          this.billing = true;

        } else {
          this.updatedBilling = true;
          this.moveToPay();
        }
        this.searchCustomer(obj, sec);
      })
      this.onCheckboxChange(this.isBillingAddressSame);
    } else {
      this[section] = true;
    }
  }

  checkEmailValidation() {
    const emailformat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
      String(this.customerData.email).toLowerCase()
    );

    if (!emailformat) {
      this.customer = true;
      this.isEmailValid = false;
    } else {
      const localUser: any = this.localStorageUser;
      if (localUser.email !== this.customerData.email) {
        localStorage.setItem("registeredEmail", this.customerData.email);
      }
      // this.shipping = true;
      this.customer = false;
      this.isEmailValid = true;
    }
  }

  onCheckboxChange(checked) {
    this.isBillingAddressSame = checked;
    if (this.isBillingAddressSame) {
      this.customerData.billing_f_Name = this.customerData.shipping_f_Name;
      this.customerData.billing_l_Name = this.customerData.shipping_l_Name;
      this.customerData.billing_company_name =
        this.customerData.shipping_company_name;
      this.customerData.billing_phone = this.customerData.shipping_phone;
      this.customerData.billing_address_line1 =
        this.customerData.shipping_address_line1;
      this.customerData.billing_address_line2 =
        this.customerData.shipping_address_line2;
      this.customerData.billing_city = this.customerData.shipping_city;
      this.customerData.billing_country = this.customerData.shipping_country;
      this.customerData.billing_state = this.customerData.shipping_state;
      this.customerData.billing_zipcode = this.customerData.shipping_zipcode;
    } else {
      this.customerData.billing_f_Name = "";
      this.customerData.billing_l_Name = "";
      this.customerData.billing_company_name = "";
      this.customerData.billing_phone = "";
      this.customerData.billing_address_line1 = "";
      this.customerData.billing_address_line2 = "";
      this.customerData.billing_city = "";
      this.customerData.billing_country = "";
      this.customerData.billing_state = "";
      this.customerData.billing_zipcode = "";
    }
  }

  shippingStateChanged() {
    this.isStateUpdating = true;
    this.stateParam = this.customerData.shipping_state;
    if (this.isPromoCodeApplicable) {
      this.apiService
        .getCartProduct(
          true,
          this.customerData.shipping_state,
          true,
          this.promoCodeDetails.code,
          this.activeWallet
        )
        .subscribe(
          (payload: any) => {
            if (this.orderAmount) {
              this.orderAmount.total_cost = payload.order.total_cost;
              this.orderAmount.sales_tax_total = payload.order.sales_tax_total;
              this.walletCreditsAvailable = payload.order.wallet_credit_available;
              this.walletCreditsUsed = payload.order.wallet_used;
              if (this.walletCreditsUsed > 0) {
                this.isWalletApplied = true;
              } else {
                this.isWalletApplied = false;
              }
              this.walletCreditsRemaining = payload.order.wallet_remaining;

              this.isStateUpdating = false;
            }
          },
          (error: any) => { }
        );
    } else {
      this.apiService
        .getCartProduct(true, this.customerData.shipping_state, false, '', this.activeWallet)
        .subscribe(
          (payload: any) => {
            if (this.orderAmount) {
              this.orderAmount.total_cost = payload.order.total_cost;
              this.orderAmount.sales_tax_total = payload.order.sales_tax_total;
              this.walletCreditsAvailable = payload.order.wallet_credit_available;
              this.walletCreditsUsed = payload.order.wallet_used;
              if (this.walletCreditsUsed > 0) {
                this.isWalletApplied = true;
              }
              this.walletCreditsRemaining = payload.order.wallet_remaining;

            }
            this.isStateUpdating = false;
          },
          (error: any) => { }
        );
    }
  }
  billingCountryChanged() {
    this.billingStatesArray = STATE_LIST;
    this.customerData.billing_zipcode = "";
    this.originalStatesList = JSON.parse(
      JSON.stringify(this.billingStatesArray)
    );
    const ct = this.country;
    if (ct == "USA") {
      this.billingStatesArray = this.originalStatesList.filter(
        (f) => f.countryCode == "USA"
      );
    } else if (ct == "Canada") {
      this.billingStatesArray = this.originalStatesList.filter(
        (f) => f.countryCode == "CN"
      );
    }
    this.customerData.billing_state = this.billingStatesArray[0].abbreviation;
    if (this.form && this.form.form) {
      this.form.form.controls['billing_country'].setValue(this.customerData.billing_country);
      this.form.form.controls['billing_state'].setValue(this.customerData.billing_state);
    }
  }

  getStatesForCountry() {
    if (this.customerData.shipping_country == "USA") {
      this.statesArray = this.originalStatesList.filter(
        (f) => f.countryCode == "USA"
      );
    } else if (this.customerData.shipping_country == "Canada") {
      this.statesArray = this.originalStatesList.filter(
        (f) => f.countryCode == "CN"
      );
    }
  }

  shippingCountryChanged() {
    this.isCountryUpdating = true;
    this.customerData.shipping_zipcode = "";
    this.statesArray = STATE_LIST;
    this.originalStatesList = JSON.parse(JSON.stringify(this.statesArray));
    this.countryParam = this.customerData.shipping_country;
    this.country = this.countryParam;
    if (this.countryParam == "USA") {
      this.statesArray = this.originalStatesList.filter(
        (f) => f.countryCode == "USA"
      );
    } else if (this.countryParam == "Canada") {
      this.statesArray = this.originalStatesList.filter(
        (f) => f.countryCode == "CN"
      );
    }
    this.customerData.shipping_state = this.statesArray[0].abbreviation;
    if (this.form && this.form.form) {
      this.form.form.controls['shipping_country'].setValue(this.customerData.shipping_country);
      this.form.form.controls['shipping_state'].setValue(this.customerData.shipping_state);
    }
    this.apiService.getCartProduct(true, this.customerData.shipping_state, this.isPromoCodeApplicable,
      this.isPromoCodeApplicable ? this.promoCodeDetails.code : '', this.activeWallet)
      .subscribe(
        (payload: any) => {
          if (this.orderAmount) {
            this.orderAmount['total_cost'] = payload.order.total_cost;
            this.orderAmount['sales_tax_total'] = payload.order.sales_tax_total;
            this.walletCreditsAvailable = payload.order.wallet_credit_available;
            this.walletCreditsUsed = payload.order.wallet_used;
            if (this.walletCreditsUsed > 0) {
              this.isWalletApplied = true;
            } else {
              this.isWalletApplied = false;
            }
            this.walletCreditsRemaining = payload.order.wallet_remaining;

          }
          this.isCountryUpdating = false;
        },
        (error: any) => { }
      );

  }

  showPromoCodeBox() {
    this.isPromoCodeBoxVisible = !this.isPromoCodeBoxVisible;
  }

  activeWallet: string = '';
  activePromo: string = '';
  applyPromoCode(clearWallet: boolean = false) {
    if (!this.promoCode) this.promoCode = '';
    if ((this.promoCode === "" || this.promoCode?.length === 0) && !clearWallet) {
      return;
    }

    this.isPromoCodeProcessing = true;
    this.promoCode = this.promoCode?.toUpperCase();
    this.promoCodeError = false;
    this.promoCodeErrorMessage = '';


    const data = {
      code: this.promoCode,
      wallet_code: this.activeWallet ? this.activeWallet : '',
      email: this.customerData?.email,
      state_code: this.customerData?.shipping_state
    }

    // if(this.a)

    this.apiService.applyPromoCode(data).subscribe((response: any) => {
      this.isPromoCodeProcessing = false;
      this.isWalletApplied = false;
      // const hasError = response.promo.status === 'invalid' && (response.wallet.status === 'invalid' || response.wallet.status === 'empty');


      const promo = response.promo || {};
      const wallet = response.wallet || {};
      let errorMessage = null;

      // 1 — Wallet failures
      if (wallet?.status?.toLowerCase() === "invalid" || wallet?.status?.toLowerCase() === "empty") {
        errorMessage = wallet.message || "This code is not valid.";
      }


      // 2 — Promo failures
      if (promo?.status?.toLowerCase() === "invalid") {
        // Promo-specific error (expired)
        if (promo?.error === "CODE_EXPIRED") {
          errorMessage = promo?.message; // "This promo code has expired."
        }
        // Generic invalid promo
        else if (promo?.error === "INVALID_PROMO" || !promo?.error) {
          errorMessage = "This code is not valid.";
        }
      }

      // 3 — If neither promo nor wallet applied, fallback to top-level error
      if (!promo?.status && !wallet?.status && response.success === false) {
        errorMessage = response.message || "This code is not valid.";
      }

      // if (errorMessage) {
      //   this.setPromoCodeIsInvalid({ message: errorMessage, ...response });

      //   return;
      // }
      // this.promoCodeDetails = null;
      // this.promoCodeError = false;


      if (errorMessage && (data.code !== '' || data.wallet_code !== '')) {
        this.updateCartUI(response.cart);
        // this.setPromoCodeIsInvalid(response);
        this.setPromoCodeIsInvalid({ ...response, message: errorMessage });

            if(response.cart && response.cart.order) {
                  this.walletCreditsAvailable = response.cart.order.wallet_credit_available;
            this.walletCreditsUsed = response.cart.order.wallet_used;
            if (this.walletCreditsUsed > 0) {
              this.isWalletApplied = true;
            } else {
              this.isWalletApplied = false;
            }
            this.walletCreditsRemaining = response.cart.order.wallet_remaining;
          }
        // this.promoCodeDetails = null;
        // this.promoCodeError = false;
        this.promoCode = '';
        return;
      }
      const isValidPromo = response.promo?.status === 'applied';
      const isValidWallet = response.wallet?.status === 'applied';
      if ((!isValidPromo || !isValidWallet) && (data.code !== '' || data.wallet_code !== '')) {
        this.setPromoCodeIsInvalid(response);
        this.promoCode = '';

      }
      this.activePromo = '';
      this.activeWallet = '';

      if (isValidPromo) {
        this.activePromo = response.promo.code;
        this.promoCodeDetails = response.cart.promo_details;
        if (this.promoCodeDetails && this.promoCodeDetails.code) {
          this.isPromoCodeApplicable = true;
          this.promoCodeDiscount = response.cart.order.total_promo_discount;
        }
        this.hideWalletMessage();
        this.promoCode = '';

      }
      if (isValidWallet) {
        this.activeWallet = response.wallet.code;
        this.isWalletApplied = true;

        this.promoCodeDetails = {
          code: this.promoCode,
          description: ''
        }
        this.updateCartUI(response.cart);
        const order = response.cart.order;

        // Show wallet deduction
        this.showWalletApplied(order.wallet_used, order.wallet_remaining, order.wallet_credit_available);

        // Zero-balance message ONLY on failed attempt
        if (order.wallet_credit_available === 0 &&
          order.wallet_used === 0) {
          this.setPromoCodeIsInvalid({ message: "This gift card has no remaining balance." });
        }

        // Hide payment fields if total = 0
        if (order.total_cost === 0 && response.wallet_only === true) {
          this.loadPayment = false;
        } else {
          this.loadPayment = true;
        }
        this.promoCode = "";
        this.showPromoCodeBox();
      } 
      this.updateCartUI(response.cart); 
      if(response.cart && response.cart.order) {
                  this.walletCreditsAvailable = response.cart.order.wallet_credit_available;
            this.walletCreditsUsed = response.cart.order.wallet_used;
            if (this.walletCreditsUsed > 0) {
              this.isWalletApplied = true;
            } else {
              this.isWalletApplied = false;
            }
            this.walletCreditsRemaining = response.cart.order.wallet_remaining;
          }

      this.isLoading = false;
 
    }, err => {
      this.isPromoCodeProcessing = false;
      this.isLoading = false;
      this.setPromoCodeIsInvalid(err.error);

    });
  }

  hideWalletMessage() {
    this.isPromoCodeApplicable = true;
    this.isWalletApplied = false;
  }

  showWalletApplied(used: number, remaining: number, available: number) {
    this.isPromoCodeApplicable = false;
    this.isWalletApplied = true;
    this.successGiftCard = this.promoCode;

    this.walletCreditsAvailable = available;
    this.walletCreditsUsed = used;
    this.walletCreditsRemaining = remaining;

  }

  updateCartUI({ products, order, promo_details }) {
    this.isLoading = false;
    this.promoCodeError = false;
    this.isPromoCodeApplicable = order.total_promo_discount > 0;
    this.promoCodeDiscount = order.total_promo_discount;
    this.orderAmount = order;
    if (promo_details) {
      this.promoCodeDetails = promo_details;
    }
    if (parseInt(order.total_cost) === 0) {
      this.loadPayment = false;
    } else {
      this.loadPayment = true;
    }
    this.cartProducts = products;
    this.cartProducts.forEach(m => {
      if (!this.allowedUser) {
        m['design_price'] = m.inventory.inventory_product_details.design_price;
        m['show_vip'] = m.inventory.inventory_product_details && m.inventory.inventory_product_details.design_price &&
          m.inventory.inventory_product_details.design_price != '0.00' && m.inventory.inventory_product_details.design_price != '0' &&
          (+m.inventory.inventory_product_details.design_price < +m.inventory.inventory_product_details.price) &&
          (+m.inventory.inventory_product_details.design_price < +m.inventory.inventory_product_details.was_price);
      }
      m['retail_price'] = m.inventory.inventory_product_details?.price;
      m['was_price'] = m.inventory.inventory_product_details.was_price;
      m["is_mto"] = m.inventory?.inventory_product_details?.is_mto;
      m["is_final"] = m.inventory?.inventory_product_details?.is_final;
      m["is_drop"] = m.inventory?.inventory_product_details?.is_drop;
      m["is_bo_drop"] = m.inventory?.inventory_product_details?.is_bo_drop;
      m["bo_date_drop"] = m.inventory?.inventory_product_details?.bo_date_drop;
      m["is_bo_lz"] = m.inventory?.inventory_product_details?.is_bo_lz;
      m["bo_date_lz"] = m.inventory?.inventory_product_details?.bo_date_lz;
      m["mto_process_time"] = m.inventory?.inventory_product_details?.mto_process_time;
    })
    this.customerData.promo = this.promoCode;
  }

  removePromoCode() {
    this.isLoading = true;
    this.isPromoCodeApplicable = false;
    this.isWalletApplied = false;
    this.walletCreditsUsed = 0;
    this.walletCreditsRemaining = 0;
    this.walletCreditsAvailable = 0;
    this.promoCodeDetails = null;
    this.promoCodeError = false;
    this.activePromo = '';
    this.applyPromoCode(true);
  }

  removeWalletCode() {
    this.isLoading = true;
    this.isWalletApplied = false;
    this.walletCreditsUsed = 0;
    this.walletCreditsRemaining = 0;
    this.walletCreditsAvailable = 0;
    this.promoCodeDetails = null;
    this.promoCodeError = false;
    this.activeWallet = '';
    this.applyPromoCode(true);
  }

  setPromoCodeIsInvalid(resp) {
    this.promoCodeError = true;
    this.promoCodeErrorMessage = resp.message;
    if (resp.cart && resp.cart.promo_details && resp.cart.promo_details.total_discount) {
      this.isPromoCodeApplicable = true;
    } else {
      this.isPromoCodeApplicable = false;
    }
    this.isPromoCodeProcessing = false;
    this.isWalletApplied = false;
    this.walletCreditsUsed = 0;
    this.walletCreditsRemaining = 0;
    this.walletCreditsAvailable = 0;
  }

  hasStateParam(): boolean {
    return !!this.stateParam;
  }
  shippingAdd: any[] = [];
  billingAdd: any[] = [];


  saveEmail(emailId) {
    this.apiService.saveCheckoutEmail(emailId).subscribe((response) => { });
    this.searchCustomer();
    setTimeout(() => {

      this.currentSection = 'shipping';
    }, 1000);
  }


  get selectedShipping() {
    return this.shippingAdd.find(f => f.selected !== -1);
  }

  get selectedBilling() {
    return this.billingAdd.find(f => f.selected !== -1);
  }


  selectAddress(data, i) {
    this.shippingAdd.forEach(f => {
      if (f.id === data.id) {
        f.selected = i;
      } else {
        f.selected = -1;
      }
    })
  }

  selectBillingAddress(data, i) {
    this.billingAdd.forEach(f => {
      if (f.id === data.id) {
        f.selected = i;
      } else {
        f.selected = -1;
      }
    })
  }



  moveToBilling() {
    this.currentSection = 'billing';
    if (!this.isBillingAddressSame) {
      this.updatedBilling = false;
      this.updatedBilling = false;
      this.payment = false;
      this.billing = true;
    }
    if (this.billingAdd.find(f => f.selected !== -1) && this.updatedBilling) {
      this.moveToPay();
    }

  }
  moveToPay() {
    if (this.selectedShipping && this.selectedBilling) {
      this.setAddress();
      this.currentSection = 'payment';
      this.payment = true;
    }
  }
  addNewAddress(isShip) {
    if (isShip) {
      this.customerData.shipping_f_Name = "";
      this.customerData.shipping_l_Name = "";
      this.customerData.shipping_company_name = "";
      this.customerData.shipping_phone = "";
      this.customerData.shipping_address_line1 = "";
      this.customerData.shipping_address_line2 = "";
      this.customerData.shipping_city = "";
      this.customerData.shipping_country = "";
      this.customerData.shipping_state = "";
      this.customerData.shipping_zipcode = "";
      this.shipping = true
    } else {
      this.customerData.billing_f_Name = "";
      this.customerData.billing_l_Name = "";
      this.customerData.billing_company_name = "";
      this.customerData.billing_phone = "";
      this.customerData.billing_address_line1 = "";
      this.customerData.billing_address_line2 = "";
      this.customerData.billing_city = "";
      this.customerData.billing_country = "";
      this.customerData.billing_state = "";
      this.customerData.billing_zipcode = "";
      this.billing = true
    }
    this.statesArray = STATE_LIST;
    this.originalStatesList = JSON.parse(JSON.stringify(this.statesArray));

    this.allCountries = COUNTRY_LIST;
    this.countryArray = COUNTRY_LIST;
  }

  setAddress() {
    if (this.selectedShipping) {
      this.customerData.shipping_f_Name = this.selectedShipping.first_Name;
      this.customerData.shipping_l_Name = this.selectedShipping.last_Name;
      this.customerData.shipping_company_name = this.selectedShipping.company_name;
      this.customerData.shipping_phone = this.selectedShipping.phone;
      this.customerData.shipping_address_line1 = this.selectedShipping.address_line_1;
      this.customerData.shipping_address_line2 = this.selectedShipping.address_line_2;
      this.customerData.shipping_city = this.selectedShipping.city;
      this.customerData.shipping_country = this.selectedShipping.country;
      this.customerData.shipping_state = this.selectedShipping.state;
      this.customerData.shipping_zipcode = this.selectedShipping.zipcode;
      this.customerData.shippingId = this.selectedShipping.id;

    }
    if (this.selectedBilling) {

      this.customerData.billing_f_Name = this.selectedBilling.first_Name;
      this.customerData.billing_l_Name = this.selectedBilling.last_Name;
      this.customerData.billing_company_name = this.selectedBilling.company_name;
      this.customerData.billing_phone = this.selectedBilling.phone;
      this.customerData.billing_address_line1 = this.selectedBilling.address_line_1;
      this.customerData.billing_address_line2 = this.selectedBilling.address_line_2;
      this.customerData.billing_city = this.selectedBilling.city;
      this.customerData.billing_country = this.selectedBilling.country;
      this.customerData.billing_state = this.selectedBilling.state;
      this.customerData.billing_zipcode = this.selectedBilling.zipcode;
      this.customerData.billingId = this.selectedBilling.id;

    }
  }

  editAddress(data: any, isShip) {

    this.statesArray = STATE_LIST;
    this.originalStatesList = JSON.parse(JSON.stringify(this.statesArray));

    this.allCountries = COUNTRY_LIST;
    this.countryArray = COUNTRY_LIST;
    this.id = data.id;

    if (isShip) {
      this.customerData.shipping_f_Name = data.first_Name;
      this.customerData.shipping_l_Name = data.last_Name;
      this.customerData.shipping_company_name = data.company_name;
      this.customerData.shipping_address_line1 = data.address_line_1;
      this.customerData.shipping_address_line2 = data.address_line_2;
      this.customerData.shipping_city = data.city;
      this.customerData.shipping_state = data.state;
      this.customerData.shipping_country = data.country;
      this.customerData.shipping_zipcode = data.zipcode;
      this.customerData.shipping_phone = data.phone;
      this.customerData.email = data.email;
      this.shipping = true;
      // if(this.selectedBilling) {

      // } else {
      // }

      // this.currentSection = 'Shipping';
    } else {
      this.customerData.billing_f_Name = data.first_Name;
      this.customerData.billing_l_Name = data.last_Name;
      this.customerData.billing_company_name = data.company_name;
      this.customerData.billing_address_line1 = data.address_line_1;
      this.customerData.billing_address_line2 = data.address_line_2;
      this.customerData.billing_city = data.city;
      this.customerData.billing_state = data.state;
      this.customerData.billing_country = data.country;
      this.customerData.billing_zipcode = data.zipcode;
      this.customerData.billing_phone = data.phone;
      this.customerData.email = data.email;
      this.billing = true;
    }
  }

  searchCustomer(obj = null, sec = null) {
    this.apiService.searchCustomer('').subscribe((res: any[]) => {

      if (res && res.length > 0) {
        res.sort((a, b) => {
          const nameA = a.first_Name?.toLowerCase() || ""; // Handle missing or undefined first_Name
          const nameB = b.first_Name?.toLowerCase() || "";
          return nameA.localeCompare(nameB);
        });
        res.forEach((f, index) => {
          f['sno'] = index,
            f['selected'] = -1;
        });
        if (obj) {
          let inx = res.findIndex(f => f.first_Name === obj.first_Name &&
            f.last_Name === obj.last_Name
          )
          if (inx > -1) {
            res[inx].selected = 0;
          } else {
            res[0].selected = 0;
          }

        } else {
          res[0].selected = 0;
        }
        // this.updatedShipping = true;


        if (sec === 'shipping' || sec === null) this.shippingAdd = JSON.parse(JSON.stringify(res));

        if (this.isBillingAddressSame || sec === 'billing') {
          this.billingAdd = JSON.parse(JSON.stringify(res));
        }

        if (this.shippingAdd.length === 1) {
          this.setAddress();
        }
        // this.isCustomer = true;
        this.shipping = false;
        if (this.isBillingAddressSame || sec === 'billing') {

          this.billing = false;
          this.moveToPay();
        } else {
          this.billing = true;

        }

        sessionStorage.setItem('user_id', '' + res[0].user_id);
        this.getCartProducts(true, this.selectedShipping.state);
        // sessionStorage.setItem('order_email', email);

      } else {
        this.shipping = true;
      }
    })
  }
  callCart() {
    this.getCartProducts(true, this.selectedShipping.state);
  }
  setAsDefaultShip(data, isShip) {
    if (isShip) {
      data.is_default_ship = 1;
    } else {
      data.is_default_billing = 1;

    }
    this.apiService.saveAddressBook(data).subscribe(resp => {
      this.searchCustomer();
    })
  }

  setAsDefaultBill(data) {
    data.is_default_bill = 1;
    this.apiService.saveAddressBook(data).subscribe(resp => {
      this.searchCustomer();
    })
  }

  get currentCardWid(): number {
    return document.getElementById('currentCardWid').clientWidth - 50;
  }
  get currentBCardWid(): number {
    return document.getElementById('currentBCardWid').clientWidth - 50;
  }
}